import React from 'react';
import { Pagination as CloudscapePagination } from '@cloudscape-design/components';
import Kendra from 'aws-sdk/clients/kendra';
import { PAGE_SIZE } from '../../constants';
import { useTranslate } from 'src/i18n/useTranslate';

interface PaginationProps {
    queryText: string;
    currentPageNumber: number;
    onSubmit: (queryText: string, currentPageNumber: number) => void;
    results: Kendra.QueryResult;
    docResults: Kendra.QueryResultItemList;
    maxPageWithResults: number;
}

export const Pagination: React.FC<PaginationProps> = ({
    queryText,
    currentPageNumber,
    onSubmit,
    docResults,
    maxPageWithResults,
}) => {
    const t = useTranslate();
    const hasDocResults = docResults && docResults.length > 0;
    const currentPageHasFullResults = docResults.length === PAGE_SIZE;

    const effectiveMaxPages = maxPageWithResults;

    if (effectiveMaxPages <= 1) {
        return null;
    }

    const handlePageChange = ({
        detail,
    }: {
        detail: { currentPageIndex: number };
    }) => {
        onSubmit(queryText, detail.currentPageIndex);
    };

    return (
        <CloudscapePagination
            currentPageIndex={currentPageNumber}
            pagesCount={effectiveMaxPages}
            onChange={handlePageChange}
            ariaLabels={{
                nextPageLabel: t('pagination_next_page', 'Next page'),
                previousPageLabel: t(
                    'pagination_previous_page',
                    'Previous page'
                ),
                pageLabel: (pageNumber) =>
                    t('pagination_page_label', `Page ${pageNumber}`, {
                        pageNumber,
                    }),
            }}
        />
    );
};
